// extracted by mini-css-extract-plugin
export default {"container":"DZ-z","heading":"EZ-z","links":"FZ-z","copy":"GZ-z","subCopy":"HZ-z","linksLeft":"IZ-z","linksCenter":"JZ-z","linksRight":"KZ-z","link":"LZ-z","onlyLink":"MZ-z"};